export enum Status {
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Acknowledged = 'Acknowledged',
  Paused = 'Paused',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Declined = 'Declined',
  Pending = 'Pending',
}

export type SelectableStatus = Status.Accepted | Status.Rejected;
export type ActionableStatus = Status.Paused | Status.Acknowledged | SelectableStatus;
export type ExecutedStatus = Status.Cancelled | Status.Completed | Status.Declined | Status.Pending;

export const SELECTABLE_TRX_STATUSES: Array<SelectableStatus> = [Status.Accepted, Status.Rejected];

interface StatusOption {
  key: string;
  value: SelectableStatus | string;
  label: SelectableStatus | string;
}
export const mapStatusToOption = (
  statuses: Array<SelectableStatus | string>,
): Array<StatusOption> => statuses.map(status => ({ key: status, value: status, label: status }));
